import { PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useField } from "formik";
import { FC, useEffect } from "react";
import styled from "styled-components";
import { organizationalUnitUserService } from "../../api/organizationalUnitUserService";
import { ApprovingUserOptionResource } from "../../types/organizationalUnitUser";

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

const Container = styled.div`
	display: grid;
	grid-auto-rows: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

const Subscript = styled.div`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

const renderOption = (option: ApprovingUserOptionResource) => {
	return (
		<Container>
			<div>
				{option.userName} ({option.userEmail})
			</div>
			<Subscript>{option.costCenterName}</Subscript>
		</Container>
	);
};

export const OrganizationalUserSelectField: FC<Props> = (props) => {
	const [, , fieldHelper] = useField<ApprovingUserOptionResource | null>(props.name);
	const { data: options, isLoading } = useQuery({
		queryKey: organizationalUnitUserService.optionsKey,
		queryFn: () => organizationalUnitUserService.options("", 1),
	});

	useEffect(() => {
		if (options?.data.data.length === 1) {
			void fieldHelper.setValue(options.data.data[0]);
		}
	}, [options, fieldHelper]);

	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={laravelServiceSelectFetchConfig(organizationalUnitUserService)}
			renderOption={renderOption}
			getLabel={(option) => `${option.userName} (${option.userEmail})`}
			disabled={isLoading}
		/>
	);
};
